module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-09.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-09.png
// module id = 1384
// module chunks = 0